<form class="register-payment-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'REGISTER_PAYMENT.HEADER' | translate }}</h4>
  @if (dataContext) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block [text]="'REGISTER_PAYMENT.HELP_TEXT.REGISTER_PAYMENT' | translate"></app-information-block>
      <div class="register-payment-form__summary">
        <span>{{ 'INVOICE.REMAINING_AMOUNT' | translate }}: </span>
        <app-money-box [dataContext]="dataContext.remainingAmount"></app-money-box>
      </div>
    </section>
  }
  <section class="astral-section-surface astral-section-surface--compact astral-form-stack">
    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
      <app-money-box [control]="form.controls['amount']" [helpText]="'REGISTER_PAYMENT.HELP_TEXT.AMOUNT'"></app-money-box>
      <astral-date-picker [control]="form.controls['date']"></astral-date-picker>
      <astral-select [control]="form.controls['companyBankAccountId']" [itemsSource]="accountSelection"></astral-select>
    </astral-layout-group>
    <astral-input
      [control]="form.controls['verificationDescription']"
      [helpText]="'REGISTER_PAYMENT.HELP_TEXT.VERIFICATION_DESCRIPTION'"
    ></astral-input>
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" [disabled]="working" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
